// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNUSED FUNCTION
// MODFIED DATA : 02-09-2025

const AutoLoanProposalActionTypes = {
	/*****************  SEARCH MEMBER LIST START  *******************/
	SEARCH_MEMBER_LIST_START: 'search_member_list_start',
	SEARCH_MEMBER_LIST_SUCCESS: 'search_member_list_success',
	SEARCH_MEMBER_LIST_FAILURE: 'search_member_list_failure',
	SEARCH_MEMBER_LIST_RESPONSE_RESET: 'search_member_list_response_reset',
	SEARCH_MEMBER_LIST_RESPONSE_CHANGED: 'search_member_list_response_changed',
	/*****************  SEARCH MEMBER LIST END  *******************/

	/*****************  CREATE AUTO LOAN NEW MEMBER BASIC DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_BASIC_START: 'add_auto_loan_member_basic_start',
	ADD_AUTO_LOAN_MEMBER_BASIC_SUCCESS: 'add_auto_loan_member_basic_success',
	ADD_AUTO_LOAN_MEMBER_BASIC_FAILURE: 'add_auto_loan_member_basic_failure',
	ADD_AUTO_LOAN_MEMBER_BASIC_RESPONSE_RESET: 'add_auto_loan_member_basic_response_reset',
	ADD_AUTO_LOAN_MEMBER_BASIC_REPONSE_CHANGED: 'add_auto_loan_member_basic_response_changed',
	/*****************  CREATE AUTO LOAN NEW MEMBER BASIC DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN NEW MEMBER ADDRESS DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_ADDRESS_START: 'add_auto_loan_member_address_start',
	ADD_AUTO_LOAN_MEMBER_ADDRESS_SUCCESS: 'add_auto_loan_member_address_success',
	ADD_AUTO_LOAN_MEMBER_ADDRESS_FAILURE: 'add_auto_loan_member_address_failure',
	ADD_AUTO_LOAN_MEMBER_ADDRESS_RESPONSE_RESET: 'add_auto_loan_member_address_response_reset',
	ADD_AUTO_LOAN_MEMBER_ADDRESS_REPONSE_CHANGED: 'add_auto_loan_member_address_response_changed',
	/*****************  CREATE AUTO LOAN NEW MEMBER ADDRESS DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN NEW MEMBER BANK DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_BANK_START: 'add_auto_loan_member_bank_start',
	ADD_AUTO_LOAN_MEMBER_BANK_SUCCESS: 'add_auto_loan_member_bank_success',
	ADD_AUTO_LOAN_MEMBER_BANK_FAILURE: 'add_auto_loan_member_bank_failure',
	ADD_AUTO_LOAN_MEMBER_BANK_RESPONSE_RESET: 'add_auto_loan_member_bank_response_reset',
	ADD_AUTO_LOAN_MEMBER_BANK_REPONSE_CHANGED: 'add_auto_loan_member_bank_response_changed',
	/*****************  CREATE AUTO LOAN NEW MEMBER BANK DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN NEW MEMBER IMAGE DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_IMAGE_START: 'add_auto_loan_member_image_start',
	ADD_AUTO_LOAN_MEMBER_IMAGE_SUCCESS: 'add_auto_loan_member_image_success',
	ADD_AUTO_LOAN_MEMBER_IMAGE_FAILURE: 'add_auto_loan_member_image_failure',
	ADD_AUTO_LOAN_MEMBER_IMAGE_RESPONSE_RESET: 'add_auto_loan_member_image_response_reset',
	ADD_AUTO_LOAN_MEMBER_IMAGE_REPONSE_CHANGED: 'add_auto_loan_member_image_response_changed',
	/*****************  CREATE AUTO LOAN NEW MEMBER IMAGE DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER COAPPLICANT DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_START: 'add_auto_loan_member_coapplicant_start',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_SUCCESS: 'add_auto_loan_member_coapplicant_success',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_FAILURE: 'add_auto_loan_member_coapplicant_failure',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_RESET:
		'add_auto_loan_member_coapplicant_response_reset',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_CHANGED:
		'add_auto_loan_member_coapplicant_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER COAPPLICANT DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT START  *******************/
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_START:
		'add_auto_loan_member_coapplicant_document_start',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_SUCCESS:
		'add_auto_loan_member_coapplicant_document_success',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_FAILURE:
		'add_auto_loan_member_coapplicant_document_failure',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_RESPONSE_RESET:
		'add_auto_loan_member_coapplicant_document_response_reset',
	ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_REPONSE_CHANGED:
		'add_auto_loan_member_coapplicant_document_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER VEHICLE DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_VEHICLE_START: 'add_auto_loan_member_vehicle_start',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_SUCCESS: 'add_auto_loan_member_vehicle_success',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_FAILURE: 'add_auto_loan_member_vehicle_failure',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_RESPONSE_RESET: 'add_auto_loan_member_vehicle_response_reset',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_REPONSE_CHANGED: 'add_auto_loan_member_vehicle_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER VEHICLE DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT START  *******************/
	ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_START: 'add_auto_loan_member_vehicle_document_start',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_SUCCESS: 'add_auto_loan_member_vehicle_document_success',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_FAILURE: 'add_auto_loan_member_vehicle_document_failure',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_RESPONSE_RESET:
		'add_auto_loan_member_vehicle_document_response_reset',
	ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_REPONSE_CHANGED:
		'add_auto_loan_member_vehicle_document_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER BUSINESS DETAIL START  *******************/
	ADD_AUTO_LOAN_MEMBER_BUSINESS_START: 'add_auto_loan_member_business_start',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_SUCCESS: 'add_auto_loan_member_business_success',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_FAILURE: 'add_auto_loan_member_business_failure',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_RESPONSE_RESET: 'add_auto_loan_member_business_response_reset',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_REPONSE_CHANGED: 'add_auto_loan_member_business_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER BUSINESS DETAIL END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER BUSINESS IMAGE START  *******************/
	ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_START: 'add_auto_loan_member_business_image_start',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_SUCCESS: 'add_auto_loan_member_business_image_success',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_FAILURE: 'add_auto_loan_member_business_image_failure',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_RESPONSE_RESET:
		'add_auto_loan_member_business_image_response_reset',
	ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_REPONSE_CHANGED:
		'add_auto_loan_member_business_image_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER BUSINESS IMAGE END  *******************/

	/*****************  CREATE AUTO LOAN MEMBER AUTO LOAN INDEX START  *******************/
	ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START: 'add_auto_loan_member_auto_loan_index_start',
	ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS: 'add_auto_loan_member_auto_loan_index_success',
	ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE: 'add_auto_loan_member_auto_loan_index_failure',
	ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET:
		'add_auto_loan_member_auto_loan_index_response_reset',
	ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED:
		'add_auto_loan_member_auto_loan_index_response_changed',
	/*****************  CREATE AUTO LOAN MEMBER AUTO LOAN INDEX END  *******************/

	/*****************  UPDATE AUTO LOAN MEMBER AUTO LOAN INDEX START  *******************/
	UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START: 'update_auto_loan_member_auto_loan_index_start',
	UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS:
		'update_auto_loan_member_auto_loan_index_success',
	UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE:
		'update_auto_loan_member_auto_loan_index_failure',
	UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET:
		'update_auto_loan_member_auto_loan_index_response_reset',
	UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED:
		'update_auto_loan_member_auto_loan_index_response_changed',
	/*****************  UPDATE AUTO LOAN MEMBER AUTO LOAN INDEX END  *******************/

	/*****************  ADD AUTO LOAN PROPOSAL START  *******************/
	ADD_AUTO_LOAN_PROPOSAL_START: 'add_auto_loan_proposal_start',
	ADD_AUTO_LOAN_PROPOSAL_SUCCESS: 'add_auto_loan_proposal_success',
	ADD_AUTO_LOAN_PROPOSAL_FAILURE: 'add_auto_loan_proposal_failure',
	ADD_AUTO_LOAN_PROPOSAL_RESPONSE_RESET: 'add_auto_loan_proposal_response_reset',
	ADD_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'add_auto_loan_proposal_response_changed',
	/*****************  ADD AUTO LOAN PROPOSAL END  *******************/

	/*****************  FETCH AUTO LOAN PROPOSAL START  *******************/
	FETCH_AUTO_LOAN_PROPOSAL_START: 'fetch_auto_loan_proposal_start',
	FETCH_AUTO_LOAN_PROPOSAL_SUCCESS: 'fetch_auto_loan_proposal_success',
	FETCH_AUTO_LOAN_PROPOSAL_FAILURE: 'fetch_auto_loan_proposal_failure',
	FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_RESET: 'fetch_auto_loan_proposal_response_reset',
	FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'fetch_auto_loan_proposal_response_changed',
	/*****************  FETCH AUTO LOAN PROPOSAL END  *******************/

	/*****************  FETCH AUTO LOAN PROPOSAL DEATIL START  *******************/
	GET_AUTO_LOAN_PROPOSAL_START: 'get_auto_loan_proposal_start',
	GET_AUTO_LOAN_PROPOSAL_SUCCESS: 'get_auto_loan_proposal_success',
	GET_AUTO_LOAN_PROPOSAL_FAILURE: 'get_auto_loan_proposal_success',
	GET_AUTO_LOAN_PROPOSAL_RESPONSE_RESET: 'get_auto_loan_proposal_response_reset',
	GET_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'get_auto_loan_proposal_response_changed',
	GET_AUTO_LOAN_PROPOSAL_RESET_COMPONENT_START: 'get_auto_loan_proposal_reset_component_start',
	/*****************  FETCH AUTO LOAN PROPOSAL DEATIL END  *******************/

	/***************** APPROVE AUTO LOAN PROPOSAL DEATIL START *******************/
	APPROVE_AUTO_LOAN_PROPOSAL_START: 'approve_auto_loan_proposal_start',
	APPROVE_AUTO_LOAN_PROPOSAL_SUCCESS: 'approve_auto_loan_proposal_success',
	APPROVE_AUTO_LOAN_PROPOSAL_FAILURE: 'approve_auto_loan_proposal_success',
	APPROVE_AUTO_LOAN_PROPODAL_RESPONSE_RESET: 'approve_auto_loan_proposal_response_reset',
	APPROVE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'approve_auto_loan_proposal_response_changed',
	/***************** APPROVE AUTO LOAN PROPOSAL DEATIL END *******************/

	/***************** REVERT AUTO LOAN PROPOSAL DEATIL START *******************/
	REVERT_AUTO_LOAN_PROPOSAL_START: 'revert_auto_loan_proposal_start',
	REVERT_AUTO_LOAN_PROPOSAL_SUCCESS: 'revert_auto_loan_proposal_success',
	REVERT_AUTO_LOAN_PROPOSAL_FAILURE: 'revert_auto_loan_proposal_success',
	REVERT_AUTO_LOAN_PROPODAL_RESPONSE_RESET: 'revert_auto_loan_proposal_response_reset',
	REVERT_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'revert_auto_loan_proposal_response_changed',
	/***************** REVERT AUTO LOAN PROPOSAL DEATIL END *******************/

	/***************** DELETE AUTO LOAN PROPOSAL DEATIL START *******************/
	DELETE_AUTO_LOAN_PROPOSAL_START: 'delete_auto_loan_proposal_start',
	DELETE_AUTO_LOAN_PROPOSAL_SUCCESS: 'delete_auto_loan_proposal_success',
	DELETE_AUTO_LOAN_PROPOSAL_FAILURE: 'delete_auto_loan_proposal_success',
	DELETE_AUTO_LOAN_PROPODAL_RESPONSE_RESET: 'delete_auto_loan_proposal_response_reset',
	DELETE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED: 'delete_auto_loan_proposal_response_changed',
	/***************** DELETE AUTO LOAN PROPOSAL DEATIL END *******************/

	/***************** APPROVE RANGE LOAN PROPOSAL START *******************/
	APPROVE_RANGE_LOAN_PROPOSAL_START: 'approve_range_loan_proposal_start',
	APPROVE_RANGE_LOAN_PROPOSAL_SUCCESS: 'approve_range_loan_proposal_success',
	APPROVE_RANGE_LOAN_PROPOSAL_FAILURE: 'approve_range_loan_proposal_failure',
	APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'approve_range_loan_proposal_response_reset',
	APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'approve_range_loan_proposal_response_changed',
	/***************** APPROVE RANGE LOAN PROPOSAL END *******************/

	/***************** DELETE RANGE LOAN PROPOSAL START *******************/
	DELETE_RANGE_LOAN_PROPOSAL_START: 'delete_range_loan_proposal_start',
	DELETE_RANGE_LOAN_PROPOSAL_SUCCESS: 'delete_range_loan_proposal_success',
	DELETE_RANGE_LOAN_PROPOSAL_FAILURE: 'delete_range_loan_proposal_failure',
	DELETE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'delete_range_loan_proposal_response_reset',
	DELETE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'delete_range_loan_proposal_response_changed',
	/***************** DELETE RANGE LOAN PROPOSAL END *******************/

	/***************** FETCH BORROWER BANK DETAIL START *******************/
	FETCH_BORROWER_BANK_DETAIL_START: 'fetch_borrower_bank_detail_start',
	FETCH_BORROWER_BANK_DETAIL_SUCCESS: 'fetch_borrower_bank_detail_success',
	FETCH_BORROWER_BANK_DETAIL_FAILURE: 'fetch_borrower_bank_detail_failure',
	FETCH_BORROWER_BANK_DETAIL_RESPONSE_RESET: 'fetch_borrower_bank_detail_response_reset',
	FETCH_BORROWER_BANK_DETAIL_RESPONSE_CHANGED: 'fetch_borrower_bank_detail_response_changed',
	/***************** FETCH BORROWER BANK DETAIL START *******************/

	/***************** GET APPROVAL MEMBER LIST START *******************/
	GET_APPROVAL_MEMBER_LIST_START: 'get_Approval_member_list_start',
	GET_APPROVAL_MEMBER_LIST_SUCCESS: 'get_Approval_member_list_success',
	GET_APPROVAL_MEMBER_LIST_FAILURE: 'get_Approval_member_lis_failure',
	GET_APPROVAL_MEMBER_LIST_RESPONSE_RESET: 'get_Approval_member_list_response_reset',
	GET_APPROVAL_MEMBER_LIST__RESPONSE_CHANGED: 'get_Approval_member_list_response_changed',
	/*****************  GET APPROVAL MEMBER LIST END  *******************/

	/***************** GET DEALER LIST START *******************/
	GET_ALL_DEALER_LIST_START: 'get_all_dealer_list_start',
	GET_ALL_DEALER_LIST_SUCCESS: 'get_all_dealer_list_success',
	GET_ALL_DEALER_LIST_FAILURE: 'get_all_dealer_list_failure',
	GET_ALL_DEALER_LIST_RESPONSE_RESET: 'get_all_dealer_list_response_reset',
	GET_ALL_DEALER_LIST__RESPONSE_CHANGED: 'get_all_dealer_list_response_changed',
	/*****************  GET  DEALER LIST  END  *******************/

	/***************** GET AUTO LOAN APPLICATION START *******************/
	GET_AUTO_LOAN_APPLICANTION_START: 'get_auto_loan_applicantion_start',
	GET_AUTO_LOAN_APPLICANTION_SUCCESS: 'get_auto_loan_applicantion_success',
	GET_AUTO_LOAN_APPLICANTION_FAILURE: 'get_auto_loan_applicantion_failure',
	GET_AUTO_LOAN_APPLICANTION_RESPONSE_RESET: 'get_auto_loan_applicantion_response_reset',
	GET_AUTO_LOAN_APPLICANTION__RESPONSE_CHANGED: 'get_auto_loan_applicantion_response_changed',
	/*****************  GET  AUTO LOAN APPLICATION  END  *******************/

	/***************** GET PERMANT PINCODE START *******************/
	GET_PERMANT_PINCODE_START: 'get_permant_pincode_start',
	GET_PERMANT_PINCODE_SUCCESS: 'get_permant_pincode_success',
	GET_PERMANT_PINCODE_FAILURE: 'get_permant_pincode_failure',
	GET_PERMANT_PINCODE_RESPONSE_RESET: 'get_permant_pincode_response_reset',
	GET_PERMANT_PINCODE__RESPONSE_CHANGED: 'get_permant_pincode_response_changed',
	/***************** GET PERMANT PINCODE END *******************/

	/***************** GET AUTO LOAN PROPOSAL LIST START *******************/
	CHECK_AUTOLOAN_MANDATORY_DETAILS_START: 'check_auto_loan_mandatory_details_start',
	CHECK_AUTOLOAN_MANDATORY_DETAILS_SUCCESS: 'check_auto_loan_mandatory_details_success',
	CHECK_AUTOLOAN_MANDATORY_DETAILS_FAILURE: 'check_auto_loan_mandatory_details_failure',
	CHECK_AUTOLOAN_MANDATORY_DETAILS_RESPONSE_RESET:
		'check_auto_loan_mandatory_details_response_reset',
	CHECK_AUTOLOAN_MANDATORY_DETAILS__RESPONSE_CHANGED:
		'check_auto_loan_mandatory_details_response_changed',
	/***************** CHECK AUTO LOAN MANDATORY DETAILS END *******************/
};
export default AutoLoanProposalActionTypes;
